const spcs = require('../../utils/SpcGroup')

const getSpcNo = (spcPk) => {
  //นักบิน scp = 100
  //แพทย์ scp = 101
  //ไมมี scp = 404
  if (spcPk >= 10 && spcPk <= 13) {
    return 100
  } else if (!spcPk) {
    return 404
  } else if ((spcPk >= 93 && spcPk <= 95) || spcPk == 0) {
    return 101
  } else {
    return spcPk
  }
}

const getPosSkillSpc = (posSkill) => {
  if (!posSkill) return '00'
  const sub2 = posSkill.substring(0, 2)
  return getSpcNo(sub2)
}

const getSpcAvailable = (posSkills, sKill01, sKill02, sKill03) => {
  if (sKill01) posSkills.push(sKill01)
  if (sKill02) posSkills.push(sKill02)
  if (sKill03) posSkills.push(sKill03)
  let result = []
  posSkills
    .filter((c, index) => {
      return posSkills.indexOf(c) === index
    })
    .map((posSkill) => {
      if (!posSkill) return
      const sub2 = posSkill.substring(0, 2)
      const found = spcs.find((e) => e.no == getSpcNo(sub2))
      if (found) result.push(found)
    })
  result = result.filter((value, index) => {
    return result.indexOf(value) === index
  })
  return result
}

export { getPosSkillSpc, getSpcNo, getSpcAvailable }
